<template>
    <div>
        <div
            class="flex items-center justify-between"
            v-if="validatedPromocode && validatedPromocode.available"
        >
            <span class="flex-grow font-secondary text-base text-blue"
                >{{ promocode }} ({{ validatedPromocode.descripcion }})</span
            >

            <btn
                class="bg-yellow hover:bg-yellow-dark text-lg text-white ml-4 px-4"
                @click="removePromocode"
            >
                {{ $config("DELETE") }}
            </btn>
        </div>

        <ValidationObserver v-else v-slot="{ handleSubmit }" class="w-full">
            <form @submit.prevent="handleSubmit(validatePromocode)" novalidate>
                <div
                    class="flex flex-col sm:flex-row items-center justify-between"
                >
                    <form-input
                        name="promo_code"
                        v-model="promocode"
                        type="text"
                        :placeholder="$config('PROMOCODE')"
                        class="flex-grow sm:mt-4 mb-2 sm:mb-0"
                        :style="{ width: '250px' }"
                        required
                    ></form-input>

                    <btn
                        class="bg-yellow hover:bg-yellow-dark text-xl text-white ml-6 px-6"
                        >{{ $config("CANJEAR") }}</btn
                    >
                </div>
            </form>
        </ValidationObserver>
    </div>
</template>

<script>
import FormInput from "./FormInput";
import Btn from "./Btn";
import api from "../api";
import requestWithInteractions from "../mixins/requestWithInteractions";

export default {
    name: "promocode",

    components: { Btn, FormInput },

    mixins: [requestWithInteractions],

    data() {
        return {
            promocode: null,
            validatedPromocode: null
        };
    },

    methods: {
        validatePromocode() {
            this.sendRequest(api.validatePromocode(this.promocode), {
                beforeSendText: this.$config("CODE_VER"),
                errorText: this.$config("CODE_ERROR"),
                successText: this.$config("PROMOCODE_VALIDATED"),

                failureCondition: ({ promocode_info }) => {
                    return !promocode_info.available;
                },

                onSuccess: ({ promocode_info }) => {
                    this.validatedPromocode = promocode_info;

                    this.$emit("validated", {
                        originalPromocode: this.promocode,
                        validatedPromocode: this.validatedPromocode
                    });
                }
            });
        },

        removePromocode() {
            this.promocode = null;
            this.validatedPromocode = null;

            this.$emit("removed");
        }
    }
};
</script>
